import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Games from '../Games';

export default class MenuButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} menuNum
   */
  constructor(scene, menuNum) {
    super(scene);

    this.menuNum = menuNum;

    this.bg = ABCyaPhaser.Images.addImage(0,0, `Menu_${this.menuNum + 1}`, this).setOrigin(0);

    if (gameData.game !== Games.alphabet) {
      const localeData = {
        x: this.bg.getBounds().width / 2,
        y: this.bg.getBounds().height - 15,
        size: 16,
        color: 0xffffff,
        text: ABCyaPhaser.Localization.instance.getLocalizedString(`menu_buttons.menu_${this.menuNum}`)
      };

      if (gameData.game === Games.face && this.menuNum === 6) {
        localeData.y = this.bg.getBounds().height - 10;
        localeData.size = 14;
        localeData.color = 0xcca144;
      }
      if (gameData.game === Games.gingerbread) {
        localeData.y = this.bg.getBounds().height - 30;
      }
      if (gameData.game === Games.pumpkin) {
        localeData.y = this.bg.getBounds().height - 35;
      }
      if (gameData.game === Games.snowman) {
        if (this.menuNum === 0) localeData.color = 0xd58112;
        if (this.menuNum === 1) localeData.color = 0x5cc9d5;

        localeData.y = this.bg.getBounds().height - 40;
      }

      this.lbl = ABCyaPhaser.Text.addText(localeData.x, localeData.y, localeData.size, localeData.color, FontKeys._BPreplay, localeData.text, this, true).setOrigin(0.5)
        .setResolution(2);
      ABCyaPhaser.Text.resizeFontToFitWidth(this.lbl, this.bg.getBounds().width - 10);
    }

    ABCyaPhaser.Container.setContainerInteractive(this, true);
  }
}